const textAreaForChatSupport = ".cc-11uv";
const emailInputField = "[name='message_field_identity-email']";
const phoneInputField = "[name='message_field_identity-phone']";

window.addEventListener("load", () => {
  try {
    function mergeObjects(array) {
      return array.reduce((acc, obj) => ({ ...acc, ...obj }), {});
    }

    const consentHistory = Object.values(dataLayer).filter(
      (a) => typeof a === "object" && a[0] === "consent"
    );
    let consents = mergeObjects(consentHistory.map((a) => a?.[2] || {}));
    if (!Object.values(consents).some((a) => a === "denied")) {
      console.log("add gtags");

      gtag("set", "allow_ad_personalization_signals", true);
      gtag("set", "allow_google_signals", true);
    } else {
      console.error("user denied services", consents);
    }
  } catch (e) {
    console.log(e);
  }

  function containsEmail(text) {
    const emailRegex = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/;
    return emailRegex.test(text);
  }

  function containsPhoneNumber(text) {
    const phoneRegex = /\d{4,}/;
    return phoneRegex.test(text);
  }

  function sendToGTM() {
    const emailFieldVal = $(emailInputField).val();
    const phoneFieldVal = $(phoneInputField).val();

    if (
      !!localStorage.getItem("chat-interaction-conversion") !== true &&
      (containsEmail(emailFieldVal) ||
        containsEmail(phoneFieldVal) ||
        containsPhoneNumber(phoneFieldVal) ||
        containsPhoneNumber(emailFieldVal))
    ) {
      console.log("SEND TO GTM");
      dataLayer.push({
        event: "chat-send-keyboard",
        inputId: this.id,
        inputValue: this.value,
      });
    }
  }

  function addInputEventListener(input) {
    input.setAttribute("data-gtm-tag-setter-key", "true");
    input.addEventListener(
      "keyup",
      function (e) {
        sendToGTM();
      },
      true
    );
  }

  function addClickEventListener(input) {
    input.setAttribute("data-gtm-tag-setter-click", "true");
    input.addEventListener(
      "click",
      function (e) {
        sendToGTM();
      },
      true
    );
  }

  function prepareEventListeners() {
    if ($(emailInputField + ":not([data-gtm-tag-setter-key])").length) {
      addInputEventListener($(emailInputField).get(0));
    }
    if ($(phoneInputField + ":not([data-gtm-tag-setter-key])").length) {
      addInputEventListener($(phoneInputField).get(0));
    }

    document
      .querySelectorAll(
        textAreaForChatSupport + ":not([data-gtm-tag-setter-key])"
      )
      .forEach(addInputEventListener);

    document
      .querySelectorAll(
        textAreaForChatSupport + ":not([data-gtm-tag-setter-click])"
      )
      .forEach(addClickEventListener);
  }

  // Create a MutationObserver to watch for added input elements
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "childList") {
        prepareEventListeners();
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  document.body.addEventListener("click", function (e) {
    prepareEventListeners();
  });

  prepareEventListeners();
});
